// Author: Luis Booth - January 2019
// 😴

import React, { Component, Fragment } from 'react';
import GuestCounter from 'js/components/step1/GuestCounter';
import TooltipWrapper from 'js/components/global/TooltipWrapper';
import { VacationContext } from 'js/components/step1/VacationContext';
import Infant from 'js/components/step1/Infant';
import Children from 'js/components/step1/Children';
// import { FormGroup } from 'react-nice-inputs';

const inputStyle = {
  padding: '1.3rem',
};

class AddGuests extends Component {
  state = {
    brandOptions: window._app.brandOptions,
    firstInteraction: false
  };

  createInfants = (contextState) => {
    const infants = [];

    const count = contextState.fields.infants;

    for (let i = 0; i < count; i++) {
      let seatType = '';

      if (contextState.guestInfo.infants) {
        seatType = contextState.guestInfo.infants[`seat_guest_${i}`];
      }

      infants.push(
        <Infant key={`infant-${i}`} infantIndex={i} seatType={seatType} />
      );
    }

    return infants;
  };

  createChildren = (childrenCount) => {
    const children = [];

    const count = childrenCount;

    for (let i = 0; i < count; i++) {
      children.push(<Children key={`children-${i}`} childrenIndex={i} />);
    }

    return children;
  };

  changeState = () => {
    const firstInteraction = true;

    this.setState({firstInteraction});
  }

  tooltipWrapperContent = (addGuestsErrors, adults, hasChildren, children, hasInfants, infants) => {
    return (
      <div
        className={`input ${
          !addGuestsErrors ? 'is-invalid' : ''
        }`}
        style={inputStyle}
      >
        <span>
          {adults} {adults === 1 ? 'Adult' : 'Adults'}
        </span>
        {hasChildren && (
          <span>
            , {children} {children === 1 ? 'Child' : 'Children'}
          </span>
        )}
        {hasInfants && (
          <span>
            , {infants} {infants === 1 ? 'Infant' : 'Infants'}
          </span>
        )}
      </div>
    );
  }

  render() {
    const { openTooltipOnMount = false, openThis } = this.props;
    const tooltipContent = (
      <VacationContext.Consumer>
        {(context) => {
          const { showGuestsWarning } = context.state;
          // const { adults: maxAdults, children: maxChildren } = guestsPerResort;

          // let { noofadults = '', noofchildren = '' } = this.props.params;
          // const { exceedsMaxOccupancy = false, maxOccupancy = 15 } = context.state;

          // const resorts = _app.freemarker.results.resorts[0].maxOccupancy;

          // console.log(resorts);

          const {
            adults = 2,
            children = 0,
            infants = 0,
            rstCode = '',
          } = context.state.fields;
          const { title: brandTitle, phoneNumber } = this.state.brandOptions;

          return (
            <div className="vw-vctn add-guest-tooltip">
              {rstCode === '' && (
                <p className="fields-error util-txt-center">
                  First select a resort
                </p>
              )}
              {showGuestsWarning && (
                <Fragment>
                  <p className="header-guest-warning">Important:</p>
                  <p className="guest-warning">
                    Air bookings may only be made for up to 8 passengers.
                    Please correct your request or call{' '}
                    {
                      <a className="bold-link" href={`tel:${phoneNumber}`}>
                        {`1-888-${brandTitle.toUpperCase()}`}
                      </a>
                    }{' '}
                    for assistance with the air portion of your booking.
                  </p>
                </Fragment>
              )}
              <div className="row">
                <div className="sm-6 guest-column">
                  <h3 className="guest-type-title">Adults</h3>
                </div>
                <div className="sm-6 guest-column util-txt-right">
                  <GuestCounter name="adults" count={adults} />
                </div>
                <span className="sm-12 guest-type-description">
                  (16 and older)
                  <span className="d-block age-label">
                    <sup className="sign-blue">*</sup> The primary guest must be
                    18 years old at the time of travel.
                  </span>
                </span>
              </div>

              <div className="row guest-type-wrapper">
                <div className="sm-6 guest-column">
                  <h3 className="guest-type-title">Children</h3>
                  <span className="guest-type-description">(2 to 15)</span>
                </div>
                <div className="sm-6 guest-column util-txt-right">
                  <GuestCounter name="children" count={children} />
                </div>
                {children > 0 && (
                  <p className="age-description sm-12 guest-column">
                    Provide ages at time of travel.
                  </p>
                )}
              </div>

              {this.createChildren(children)}

              <div className="row guest-type-wrapper">
                <div className="sm-6 guest-column">
                  <h3 className="guest-type-title">Infants</h3>
                  <span className="guest-type-description">(0 to 2)</span>
                </div>
                <div className="sm-6 guest-column util-txt-right">
                  <GuestCounter name="infants" count={infants} />
                </div>
                {this.createInfants(context.state)}
                <div className="sm-12 guest-column age-label">
                  <sup>*</sup> Infants must be less than 2 years old at the time
                  of travel.
                </div>
              </div>
            </div>
          );
        }}
      </VacationContext.Consumer>
    );

    return (
      <VacationContext.Consumer>
        {(context) => {
          const {
            adults = 1,
            children = 0,
            infants = 0,
          } = context.state.fields;
          const hasChildren = children > 0;
          const hasInfants = infants > 0;
          const { fieldValidations } = context.state;
          const { addGuestsErrors } = fieldValidations;

          return (
            <div className="row middle-md">
              <h3 className="sm-12 lg-6 primary-heading">Number of Guests</h3>
              <div className="sm-12 lg-6 number-of-guest" onClick={() => this.changeState()}>
                <div
                  className={`select-wrap ${
                    !addGuestsErrors ? 'is-invalid' : ''
                  }`}
                >
                  {(openThis) && // The reason of these two tooltipWrappers is to avoid a visual bug when you add more than 8 guests in the "Number of Guest" modal. 
                    <TooltipWrapper
                      openOnMount={openTooltipOnMount}
                      content={tooltipContent}
                      contentClass="full-width"
                      direction="down-center"
                      forceDirection
                      tagName="div"
                      withCloseButton
                      isVisible={openThis ? true : false}
                    >
                      {this.tooltipWrapperContent(addGuestsErrors, adults, hasChildren, children, hasInfants, infants)}
                    </TooltipWrapper>
                  }
                  {(!openThis) &&
                    <TooltipWrapper
                      openOnMount={openTooltipOnMount}
                      content={tooltipContent}
                      contentClass="full-width"
                      direction="down-center"
                      forceDirection
                      tagName="div"
                      withCloseButton
                      isVisible={this.state.firstInteraction}
                    >
                      {this.tooltipWrapperContent(addGuestsErrors, adults, hasChildren, children, hasInfants, infants)}
                    </TooltipWrapper>
                  }
                </div>
              </div>
            </div>
          );
        }}
      </VacationContext.Consumer>
    );
  }
}

export default AddGuests;



// WEBPACK FOOTER //
// ./js/components/step1/AddGuests.js